<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <h1>End User Licence Agreement</h1>
                            <terms-and-conditions></terms-and-conditions>
                        </div>
                    </div>
                </div>

            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import TermsAndConditions from '@/components/User/TermsAndConditions';

export default {
  name: 'EULA',
  components: {
    TermsAndConditions,
  },
};
</script>
<style lang="scss">
</style>
